import React, { Component } from "react";
import { Link } from "react-router-dom";

class Footer extends Component {
  render() {

    const year = new Date().getFullYear();

    return (
      <div className="footer">
        <div className="container">
          <div
            className="row justify-content-center"
            style={{ fontSize: "150%" }}
          >
            <div className="col-4 offset-xs-1 col-sm-2">
              <h5>Ссылки</h5>
              <ul id="footer-links" className="list-unstyled">
                <li onClick={() => window.scrollTo(0, 0)}>
                  <Link to="/home">Домой</Link>
                </li>
                <li onClick={() => window.scrollTo(0, 0)}>
                  <Link to="/files">Файлы</Link>
                </li>
                {/* <li>
                  <Link to="/articles">Статьи</Link>
                </li> */}
                <li onClick={() => window.scrollTo(0, 0)}>
                  <Link to="/gallery">Галерея</Link>
                </li>
                {/* <li>
                  <Link to="/contacts">Контакты</Link>
                </li> */}
              </ul>
            </div>
            <div className="col-7 col-sm-5 ml-3 ml-md-0">
              <h5>Адрес</h5>
              <address id="footer-address">
                str. Studentilor 9/7, 4 этаж, 403 каб.
                <br />
                Кишинев
                <br />
                <i className="fa fa-phone fa-lg"></i>:{" "}
                <a href="tel:+37379702363"> 079 702363</a>
                <br />
                <i className="fa fa-phone fa-lg"></i>:{" "}
                <a href="tel:+373022924532"> 022 92-45-32</a>
                <br />
                <i className="fa fa-envelope fa-lg"></i>:{" "}
                <a style={{"overflowWrap": "break-word"}} href="mailto:bulatviktor.64@gmail.com">bulatviktor.64@gmail.com</a>
              </address>
            </div>
            <div className="col-12 col-sm-4 align-self-center">
              <div className="text-center">
                {/* <a
                  className="btn btn-social-icon btn-facebook ml-2"
                  href="http://www.facebook.com/profile.php?id="
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  <i className="fa fa-facebook"></i>
                </a> */}
                <a
                  className="btn btn-social-icon viber ml-2"
                  href="viber://chat?number=+37379702363">
                  <img
                    alt="Viber"
                    style={{"WebkitFilter": "invert(100%)", "filter": "invert(100%)"}}
                    height="32"
                    width="32"
                    src="assets/images/viber-brands.svg"/>
                </a>
                <a
                  className="btn btn-social-icon mail ml-2"
                  href="mailto:bulatviktor.64@gmail.com">
                  <i className="fa fa-envelope"
                  style={{"WebkitFilter": "invert(100%)", "filter": "invert(100%)"}}
                  ></i>
                </a>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-auto">
              <p style={{"textAlign": "center"}}>© Copyright {year} Военная Кафедра UTM</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
